// extracted by mini-css-extract-plugin
export var heroImage = "_ks-1";
export var modal = "_ks-0";